<formly-form
  [form]="form"
  [model]="model"
  [fields]="fields"
  [options]="options"
>
</formly-form>
<button
  class="btn-accello-ternary w-100 mt-3 border-0"
  type="submit"
  [disabled]="!isFormValid"
  (click)="viewTestCases()"
>
  <span>
    <img src="assets/images/virtusa-icons/remove.png" alt="remove" />
  </span>
  {{ selectedDetails ? 'Selected: ' + selectedDetails.selectedTestCaseDetails.length + '/' + selectedDetails.totalTestCases + ' Test Cases' : 'View Test Cases' }}
</button>
<button
  class="btn-accello-primary w-100 mt-3"
  type="button"
  [disabled]="!selectedDetails"
  (click)="onGenerateTestScripts()"
>
  <span class="v-center">
    <img src="assets/images/virtusa-icons/generate.svg" alt="reload" />
  </span>
  Generate Test Cases
</button>
